import { __rest } from 'tslib';
import React, { useState, useEffect } from 'react';
import { Viewer } from '../components/pannellum-viewer/index.js';
import { EditorBaseMenu } from './components/base-menu/EditorBaseMenu.js';
import { EditorButtonMenu } from './components/button-menu/EditorButtonMenu.js';
import { EditingButtonMenu } from './components/button-menu/EditingButtonMenu.js';
import '../../types/AccessDevice.js';
import '../../types/Analytics.js';
import '../../types/CASACommunity.js';
import '../../types/Community.js';
import '../../types/DxSettings.js';
import '../../types/MagicButton.js';
import { PitchWarningType } from '../../types/Pannellum.js';
import '../../types/Prospect.js';
import '../../types/ProspectIntelligence.js';
import '../../types/Space.js';
import '../../types/Tour.js';
import { HotspotEditingTooltip } from './components/button-menu/hotspot-menu/HotspotEditingTooltip.js';
import '../../services/base/baseDiscoverService.js';
import '../../services/base/baseV3Service.js';
import '../../services/sgtService.js';
import '@analytics/storage-utils';
import 'date-fns/format';
import 'date-fns/secondsToMinutes';
import 'date-fns/isValid';
import 'date-fns/addMinutes';
import 'date-fns';
import 'date-fns-tz';
import { useError } from '../../utils/ErrorProvider.js';
import '../../utils/LoaderProvider.js';
import { useRefetch } from '../../utils/RefetchProvider.js';
import '../../utils/NotificationProvider.js';
import '../../utils/ContactProvider.js';
import '../../utils/PolicyProvider.js';
import '../../utils/AnalyticsProvider.js';
import '../../utils/analyticsPlugin.js';
import '../../utils/communityGoogleAnalyticsPlugin.js';
import 'qs';
import '../../utils/cookieUtils.js';
import '../../utils/termsConditionsAgreementsUtils.js';
import '../../services/base/analyticsV2BaseService.js';
import 'axios';
import '../../services/base/internalApiBaseService.js';
import '../../services/base/casaBaseService.js';
import '../../services/scanRequestsService.js';
import '../../services/db/insightsReportsDB.js';
import 'dot-object';
import '../../apis/analytics/useDownloadAnalyticsReports.js';
import { useSpaceById } from '../../apis/space/useSpaceById.js';
import '../../apis/upload/useSignedURL.js';

const BaseEditor = (_a) => {
    var { id, onLoad, onError, enableVirtualStaging } = _a, props = __rest(_a, ["id", "onLoad", "onError", "enableVirtualStaging"]);
    const [isEditing, setIsEditing] = useState(false);
    const [extractPhotoTool, setExtractPhotoTool] = useState(false);
    const [createHotspotTool, setCreateHotspotTool] = useState(null);
    const [getSpaceById, spaceDetails, spaceDetailsLoading, spaceDetailsError] = useSpaceById();
    const { refetch } = useRefetch();
    const { setError } = useError();
    useEffect(() => {
        id && getSpaceById({ id });
    }, [id, refetch]);
    useEffect(() => {
        if (spaceDetailsError) {
            onError && onError(spaceDetailsError);
            setError(spaceDetailsError === null || spaceDetailsError === void 0 ? void 0 : spaceDetailsError.message);
        }
    }, [spaceDetailsError]);
    useEffect(() => {
        onLoad && onLoad(spaceDetails);
    }, [spaceDetails]);
    const toggleExtractPhotoTool = () => {
        setExtractPhotoTool((extractPhotoTool) => !extractPhotoTool);
    };
    const toggleCreateHotspotTool = (type, modal, linkBackSceneId, linkBackStep) => {
        setCreateHotspotTool({ type, modal, linkBackSceneId, linkBackStep });
    };
    const toggleEditing = () => {
        setIsEditing((isEditing) => !isEditing);
    };
    //@ts-ignore
    const showBaseMenu = (!extractPhotoTool && !createHotspotTool) || (createHotspotTool && !createHotspotTool.type);
    const [pitchType, setPitchType] = useState(null);
    const onCloseWarningTooltip = () => {
        setPitchType(null);
    };
    return (React.createElement(Viewer, Object.assign({}, props, { spaceId: id, isDetailsLoading: spaceDetailsLoading, details: spaceDetails, isEditing: isEditing }),
        (!isEditing && (React.createElement(React.Fragment, null,
            React.createElement(EditorButtonMenu, { onEditTour: toggleEditing, toggleExtractPhotoTool: toggleExtractPhotoTool, extractPhotoTool: extractPhotoTool })))) || (React.createElement(EditingButtonMenu, { setPitchWarning: setPitchType, createHotspotTool: createHotspotTool, toggleCreateHotspotTool: toggleCreateHotspotTool, onDoneEditTour: toggleEditing, enableVirtualStaging: enableVirtualStaging })),
        showBaseMenu && React.createElement(EditorBaseMenu, null),
        pitchType === PitchWarningType.High && (React.createElement(HotspotEditingTooltip, { title: "Warning", onCloseWarningTooltip: onCloseWarningTooltip, description: "This link has been placed very high! This should only be used for linking different floors" })),
        pitchType === PitchWarningType.Low && (React.createElement(HotspotEditingTooltip, { title: "Warning", onCloseWarningTooltip: onCloseWarningTooltip, description: "This link has been placed very low! This should only be used for linking different floors" }))));
};

export { BaseEditor, BaseEditor as default };
